import { createUseStyles } from 'react-jss';
import { ITheme, mediaQuery } from '@quicktools/shared-components/styles';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      marginBlockStart: 32,

      [mediaQuery(breakpoints.mobile)]: {
        marginBlockStart: 24,
      },
    },
    text: {
      marginBottom: 16,

      [mediaQuery(breakpoints.mobile)]: {
        fontSize: 20,
        marginBottom: 12,
      },
    },
    btnContainer: {
      padding: [32, 0, 64],

      [mediaQuery(breakpoints.mobile)]: {
        marginBlockStart: 40,
        marginBlockEnd: 24,
        padding: 0,
      },
    },
    openBtn: {
      marginInlineEnd: 16,

      [mediaQuery(breakpoints.mobile)]: {
        marginBlockEnd: 12,
        width: '100%',
      },
    },
    toolsBtn: {
      [mediaQuery(breakpoints.mobile)]: {
        width: '100%',
      },
    },
    secondPartBtn: {
      fontWeight: 400,
    },
  }),
  {
    name: 'GenerateExample',
  },
);

export default useStyles;
